var exports = {
  "kL": "x804f0401--4bb3eb--container",
  "Qs": "x804f0401--4bb3eb--content",
  "wx": "x804f0401--4bb3eb--header",
  "Qq": "x804f0401--4bb3eb--text",
  "XI": "x804f0401--4bb3eb--action",
  "Sl": "x804f0401--4bb3eb--image",
};

module.exports = exports;
